module.exports = __webpack_public_path__ + "img/35-green.475779e5.svg";